/* tslint:disable */
/* eslint-disable */
export enum TriggerEventType {
  SelfCheckinDriverWaiting = 'self_checkin_driver_waiting'
}
